import { useState } from 'react'
import Table from '~/components/Table'
import { Heading } from '@weareberyl/design-system'
import {
  LoadingComponent,
  ErrorComponent,
  EmptyComponent,
} from '~/components/Query/utils'
import { compareAndShortenGeoms } from '~/utils'
import { useZoneDiffQuery } from '~/gql/generated/graphql'

export default ({ zone, columns }) => {
  const [[oldGeom, newGeom], setGeom] = useState(['-', '-'])

  const { loading, error, data } = useZoneDiffQuery({
    variables: { id: zone.id },
    pollInterval: 0,
    onCompleted: () => {
      setGeom(compareAndShortenGeoms(data?.zone?.geom, zone?.geom))
    },
  })

  const cols = [
    {
      title: '',
      dataIndex: 'diffType',
      render: diffType => <Heading variant="h4">{diffType}</Heading>,
    },
    ...columns,
    {
      title: 'Geometry',
      dataIndex: 'geom',
    },
  ]

  if (error) {
    return <ErrorComponent error={error} />
  }

  if (loading) {
    return <LoadingComponent />
  }

  if (!data) {
    return <EmptyComponent />
  }

  return (
    <Table
      id="zones-sync-table-diff"
      columns={cols}
      hideProgress
      data={{
        table: {
          pagination: false,
          nodes: [
            {
              ...zone,
              is_suspended: data.zone?.is_suspended,
              geom: newGeom,
              diffType: 'New',
            },
            { ...data.zone, id: 'old', geom: oldGeom, diffType: 'Old' },
          ],
        },
      }}
    />
  )
}
